import React from 'react';
import './Supervision.css';

const SidebarProfile = () => (
  <aside className="sidebar-profile">
    <img src="./vinhkhiem_picture_picture.jpg" alt="Khiem Vinh Tran" className="sidebar-profile-img" />
    <h2 className="sidebar-profile-name">Khiem Vinh Tran</h2>
    <p className="sidebar-profile-title">Research Staff Member & Associate Lecturer</p>
    <p className="sidebar-profile-department">Faculty of Information System & Information System Laboratory</p>
    <p className="sidebar-profile-university">University of Information Technology, Vietnam National University, Ho Chi Minh City</p>
    <div className="profile-location">
      <i className="fas fa-map-marker-alt"></i>
      <span>
        <a href="https://maps.app.goo.gl/zVvn2fYphGEJXVRF7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#007bff' }}>
          Room E9.1, UIT-VNUHCM, Quarter 6, Linh Trung, Thu Duc City
        </a>
      </span>
    </div>
    <div className="sidebar-social-links">
      <a href="mailto:khiemtv@uit.edu.vn" className="sidebar-social-link email" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-envelope"></i> Email
      </a>
      <a href="https://scholar.google.com.vn/citations?user=XT2PrJQAAAAJ&hl=vi" className="sidebar-social-link scholar" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-graduation-cap"></i> Google Scholar
      </a>
      <a href="https://orcid.org/0000-0001-7128-2058" className="sidebar-social-link orcid" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-orcid"></i> ORCID
      </a>
      <a href="https://www.linkedin.com/in/khiem-tran-vinh/" className="sidebar-social-link flickr" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin"></i> LinkedIn
      </a>
      <a href="https://www.instagram.com/kvt0012/" className="sidebar-social-link instagram" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i> Instagram
      </a>
    </div>
  </aside>
);

const Supervision = () => {
  return (
    <main className="main">
      <div className="sidebar-layout">
        <SidebarProfile />
        <div className="container">
          <div className="page-header">
            <h1>Supervision</h1>
          </div>
          <div className="content-section supervision-content">
            <h2>Present</h2>
            <ul className="student-list">
              <li className="student-item">
                <span className="student-name">Nguyen Thanh Chau - Nguyen Huy Hoang </span> (2025)
                <ul>
                  <li>Undergraduate</li>
                </ul>
              </li>
            </ul>
            <h2>Past</h2>
            <ul className="student-list">
              <li className="student-item">
                <span className="student-name">Le Quang Hoa - Kieu Xuan Dieu Huong</span> (2024)
                <ul>
                  <li>Undergraduate</li>
                  <li>Thesis: "LAWVIVQA A VISUAL QUESTION ANSWERING DATASET FOR
                  VIETNAMESE LEGAL CONTENT", Score: 9.4/10 </li>
                  <li>Currently an AI Engineer and UI/UX Designer at Smart Digitech in Vietnam</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Supervision; 